import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const HeroBanner: React.FC = () => {
  const [animate, setAnimate] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-blue-50 to-white py-8 md:py-12">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-0 right-20 w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-10 left-1/3 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>

        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `radial-gradient(#3b82f6 1px, transparent 1px)`,
          backgroundSize: '30px 30px'
        }}></div>

        <svg className="absolute top-0 left-0 w-full h-full opacity-10" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="eth-grid" width="100" height="100" patternUnits="userSpaceOnUse">
              <path d="M0 50 L100 50 M50 0 L50 100" stroke="#3b82f6" strokeWidth="0.5" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#eth-grid)" />
        </svg>
      </div>
      <img src="/logo2.png" alt="EFPower Logo" className="w-24 mx-auto mb-5"/>
      <div className="container max-w-6xl mx-auto px-4 relative z-10">
        <div className="text-center">
          <div className={`transform transition-all duration-1000 ${animate ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">
              {t('header.title')}
            </h1>
          </div>
          
          <div className={`transform transition-all duration-1000 delay-200 ${animate ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            {t('header.intro')}
            </p>
          </div>
          
          <div className={`mt-10 flex justify-center transition-all duration-1000 delay-500 ${animate ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <div className="p-1 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600">
              <div className="bg-white p-1 rounded-full">
                <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"></div>
              </div>
            </div>
          </div>

          <div className="flex justify-center space-x-4 mt-10">
            <div className={`transition-all duration-1000 delay-700 transform ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="bg-white py-2 px-4 rounded-full shadow-lg flex items-center">
                <span className="w-3 h-3 bg-green-400 rounded-full mr-2"></span>
                <span className="text-sm font-medium text-gray-800">{t('header.b1')}</span>
              </div>
            </div>
            
            <div className={`transition-all duration-1000 delay-800 transform ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="bg-white py-2 px-4 rounded-full shadow-lg flex items-center">
                <span className="text-yellow-500 mr-1">⭐</span>
                <span className="text-sm font-medium text-gray-800">{t('header.b2')}</span>
              </div>
            </div>
            
            <div className={`transition-all duration-1000 delay-900 transform ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="bg-white py-2 px-4 rounded-full shadow-lg flex items-center">
                <span className="text-blue-500 mr-1">⚡</span>
                <span className="text-sm font-medium text-gray-800">{t('header.b3')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner; 